import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getLinksAggregation } from "../api";
import { linksKeys } from "./keys";

// Totals across the current search (visits / donations / amount). Keyed by the
// applied search so it refetches automatically when the search is applied.
export const useLinksAggregationQuery = (search) =>
  useQuery({
    queryKey: linksKeys.aggregation(search),
    queryFn: async () => {
      const { data } = await getLinksAggregation(search);
      return data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
